<template lang='pug'>
el-card

  div(slot='header')
    i.mat-icon restaurant_menu
    | Request preferences

  el-form(
    v-if='preferences != null',
    ref='preferencesForm',
    :rules='rules',
    :model='preferences'
    :label-position='labelPosition', :label-width='labelWidth'
  )

    el-form-item(label='Order preferences', prop='budget')
      preferences-builder(:initial-value='preferences', ref='preferencesBuilder')

    el-form-item(label='Budget per person', prop='budget')
      el-input(v-model='preferences.budget')
        template(slot='prepend')
          | $

    el-form-item
      el-button(
        type="primary",icon="el-icon-add",
        @click="onSave", :loading='saving'
      ) Save
</template>

<script>
  import Vue from 'vue'
  import PreferencesBuilder from './PreferencesBuilder.vue'

  function data(){
    return {
      saving: false,
      rules: {},
      preferences: null
    }
  }

  function getPreferences(){
    this.$simplecater.get('/preferences').then((r)=> {
      const preferences = r.data.data
      this.preferences = {
        ...preferences, budget: preferences.budget_cents / 100
      }
    })
  }

  function updatePreferences(){
    const submitData = Object.assign(
      {},
      this.$refs.preferencesBuilder.preferences,
      { budget_cents: this.preferences.budget * 100 }
    )
    this.savingPreferences = true
    this.$simplecater.put('/preferences', submitData).then((r)=> {
      this.savingPreferences = false
      this.$message.info("Your preferences have been updated")
    }).catch(()=>{
      this.savingPreferences = false
      // TODO catch
      this.$message.error("The operation failed, please try again")
    })
    console.log("SENDING", submitData)
  }

  function created(){
    this.getPreferences()
  }

  function onSave(){
    this.$refs.preferencesForm.validate((valid)=>{
      if (valid) {
        this.updatePreferences()
      }else{
        this.$message.error("Please check your input")
      }
    })
  }

  const methods = {
    onSave, getPreferences, updatePreferences
  }

  const props = {
    labelWidth: { default: Vue.$labelWidth },
    size: { default: Vue.$defaultFormSize },
    labelPosition: { default: Vue.$defaultlabelPosition },
    displaySave: {default: false}
  }

  const components = { PreferencesBuilder }

  export default { props, data, methods, created, components }
</script>



// WEBPACK FOOTER //
// src/user/blocks/AccountPreferences.vue